import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthPayloadSuccess } from '../../lib/authenticate';
import { identifyUser } from '../../lib/identifyUser';
import { tc } from '../../lib/trackingContext';
import { hrefFor } from '../../routers';
import { useUser } from '../useUser';

type CompleteAuthArgs = {
  user: AuthPayloadSuccess;
  remember?: boolean;
  guest?: boolean;
  opted_in?: boolean;
};

export const useCompleteAuth = () => {
  const { pathname } = useLocation();
  const { setUserData } = useUser();
  const isCheckoutPage = pathname === hrefFor.CheckoutPage();

  const handleTrackSignedIn = useCallback(
    (user: AuthPayloadSuccess, optedIn?: boolean) => {
      tc.track('Signed In', {
        addToScopeOnce: {
          user
        },
        addToTrackingEvent: { label: user.id }
      });

      if (isCheckoutPage && optedIn === true) {
        tc.track('Email Signup Submitted', {
          addToTrackingEvent: {
            label: 'checkout',
            category: 'Marketing Email'
          },
          addToScopeOnce: {
            user
          }
        });
      }
    },
    [isCheckoutPage]
  );

  return useCallback(
    async ({ user, remember, guest, opted_in: optedIn }: CompleteAuthArgs) => {
      await setUserData({ remember, isLoggedIn: !guest, ...user });
      identifyUser(user);
      handleTrackSignedIn(user, optedIn);

      return user;
    },
    [handleTrackSignedIn, setUserData]
  );
};
